import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';

import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import { SaveOutlined } from '@material-ui/icons';

import { Empty } from 'antd';
import '@styles/AntStyles.css';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import {
  DivLoading,
  SpinnerLoadingMaterial,
  StyledTableCell,
  StyledTableCell2,
  StyledTableCell3,
  StyledTableCell0,
  StyledTableRow,
  useStyles,
  Container,
  DivVoid,
  StyledTableRow2,
} from './styles';
import { Box, Collapse, IconButton } from '@material-ui/core';

interface ITableProps {
  data: object[];
  columns: Object[];
  loading: Boolean;
  ActionHeader?: string;
  Actions?: IActionObj[];
  Selected?: Function;
  FieldsBold?: string[];
  keys: string[];
  ItemBottom?: React.ReactNode;
}

interface IActionObj {
  Button: Function;
}

const TableColapse: React.FC<ITableProps> = ({
  data,
  columns,
  loading,
  Actions,
  ActionHeader,
  Selected,
  FieldsBold,
  ItemBottom,
  keys,
}) => {
  const classes = useStyles();
  // const keys = Object.keys(data[0] || data);
  const alterColumns = columns[0] || {};

  const [statusSelected, setStatusSelected] =
    React.useState<string>('');

  const Head = ({ keys, alterColumns }: any) => {
    return (
      <>
        {Selected && (
          <StyledTableCell align="center">Selecionar</StyledTableCell>
        )}

        {keys.map((key: any) => (
          <StyledTableCell key={key} align="center">
            {alterColumns[key] || key}
          </StyledTableCell>
        ))}

        {Actions && (
          <StyledTableCell align="center">
            {ActionHeader !== null ? ActionHeader : 'Opções'}
          </StyledTableCell>
        )}
      </>
    );
  };

  const Rows = ({ row }: any) => {
    const colunas = Object.keys(row);
    const [open, setOpen] = React.useState(false);

    return (
      <>
        {console.log(colunas)}
        <StyledTableRow>
          <StyledTableCell align="right">{row.data_doacao}</StyledTableCell>
          <StyledTableCell align="right">{row.valor_doacao}</StyledTableCell>
          <StyledTableCell align="right">{row.origem_doacao_descricao}</StyledTableCell>
          <StyledTableCell align="right">{row.campanha_descricao}</StyledTableCell>
          <StyledTableCell0>
            <IconButton
              aria-label="expand row"
              size="small"
              disabled={row.observacao === ''}
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </StyledTableCell0>
        </StyledTableRow>
        <StyledTableRow>
          <StyledTableCell
            style={{ paddingBottom: 0, paddingTop: 0, padding: 0 }}
            colSpan={7}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Table className={classes.table}>
                <TableBody>
                    <StyledTableRow2>
                      <StyledTableCell2 style={{marginLeft: '5%'}}>Motivo recusa: { row.observacao}</StyledTableCell2>
                      <StyledTableCell2 style={{marginLeft: '5%'}}>Responsável: {row.usuarioRecusaNome}</StyledTableCell2>
                    </StyledTableRow2>
                </TableBody>
              </Table>
            </Collapse>
          </StyledTableCell>
        </StyledTableRow>
      </>
    );
  };

  return (
    <Container>
      {loading && (
        <DivLoading>
          <SpinnerLoadingMaterial />
        </DivLoading>
      )}

      {!loading && data.length <= 0 && (
        <DivVoid>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Nenhum dado encontrado"
          />
        </DivVoid>
      )}

      <TableContainer className={classes.container}>
        <Table className={classes.table} stickyHeader size="medium">
          {!loading && (
            <TableHead>
              <TableRow>
                <Head keys={keys} alterColumns={alterColumns} />
              </TableRow>
            </TableHead>
          )}

          <TableBody>
            {data.map((row: any, index: number) => {
              return <Rows key={index} row={row} />;
            })}
          </TableBody>
          <TableFooter></TableFooter>
        </Table>
      </TableContainer>
      {ItemBottom}
    </Container>
  );
};

export default TableColapse;
